import $ from 'jquery';
import '../utils/magnific-popup-esm.js';

$(function () {
  $('.open-popup-link').magnificPopup({
    type: 'inline',
    midClick: true
  });
});
